import { defineMessages } from "@formatjs/intl";
export default defineMessages({
  firstNameLabel: {
    id: "profileSettings.firstNameLabel",
    defaultMessage: "First Name"
  },
  middleNameLabel: {
    id: "profileSettings.middleNameLabel",
    defaultMessage: "Middle Name"
  },
  lastNameLabel: {
    id: "profileSettings.lastNameLabel",
    defaultMessage: "Last Name"
  },
  firstNamePlaceHolder: {
    id: "profileSettings.firstNamePlaceHolder",
    defaultMessage: "User First Name"
  },
  middleNamePlaceHolder: {
    id: "profileSettings.middleNamePlaceHolder",
    defaultMessage: "User Middle Name"
  },
  lastNamePlaceHolder: {
    id: "profileSettings.lastNamePlaceHolder",
    defaultMessage: "User Last Name"
  },
  emailLabel: {
    id: "profileSettings.emailLabel",
    defaultMessage: "Email"
  },
  phoneLabel: {
    id: "profileSettings.phoneLabel",
    defaultMessage: "Phone"
  },
  passwordLabel: {
    id: "profileSettings.passwordLabel",
    defaultMessage: "Password"
  },
  confirmPasswordLabel: {
    id: "profileSettings.confirmPasswordLabel",
    defaultMessage: "Confirm Password"
  },
  emailPlaceHolder: {
    id: "profileSettings.emailPlaceHolder",
    defaultMessage: "User Email"
  },
  phonePlaceHolder: {
    id: "profileSettings.phonePlaceHolder",
    defaultMessage: "User Phone"
  },
  passwordPlaceHolder: {
    id: "profileSettings.passwordPlaceHolder",
    defaultMessage: "User Password"
  },
  confirmPasswordPlaceHolder: {
    id: "profileSettings.confirmPasswordPlaceHolder",
    defaultMessage: "Confirm Password"
  },
  saveButton: {
    id: "profileSettings.saveButton",
    defaultMessage: "Save User"
  },
  uploadPicLabel: {
    id: "profileSettings.uploadPicLabel",
    defaultMessage: "Upload Your Picture"
  },
  myProfileSubTitle: {
    id: "profileSettings.myProfileSubTitle",
    defaultMessage: "My Profile"
  },
  editTitle: {
    id: "profileSettings.editTitle",
    defaultMessage: "Edit"
  },
  verifyEmailInstructionsPart1: {
    id: "profileSettings.verifyEmailInstructionsPart1",
    defaultMessage: "Now you can reset your password and sign-in using your email anytime."
  },
  verifyEmailInstructionsPart2: {
    id: "profileSettings.verifyEmailInstructionsPart2",
    defaultMessage: "In order to do that, please enter your valid email address which you have access to."
  },
  verifyTypography: {
    id: "profileSettings.verifyTypography",
    defaultMessage: "Verify"
  },
  enterEmailMsg: {
    id: "profileSettings.enterEmailMsg",
    defaultMessage: "Enter your email address"
  },
  notValidEmailErrorMsg: {
    id: "profileSettings.notValidEmailErrorMsg",
    defaultMessage: "Not a valid email address"
  },
  verifyEmailLabel: {
    id: "profileSettings.verifyEmailLabel",
    defaultMessage: "Verify Your Email"
  },
  emailVerificationLabel: {
    id: "profileSettings.emailVerificationLabel",
    defaultMessage: "Email Verification"
  },
  verificationEmailSentMsg: {
    id: "profileSettings.verificationEmailSentMsg",
    defaultMessage: "We have sent verification link to your email, please check your inbox and spam."
  },
  emailExpirationNote: {
    id: "profileSettings.emailExpirationNote",
    defaultMessage: "Note: verification link expires in 1 hour."
  },
  resendEmailQuestion: {
    id: "profileSettings.resendEmailQuestion",
    defaultMessage: "Didn't receive the email? You can"
  },
  accountVerifiedConfirmationMsg: {
    id: "profileSettings.accountVerifiedConfirmationMsg",
    defaultMessage: "Voila! You have successfully verified your account."
  },
  invalidURLMsg: {
    id: "profileSettings.invalidURLMsg",
    defaultMessage: "Invalid URL"
  },
  invalidURLDetailedMsg: {
    id: "profileSettings.invalidURLDetailedMsg",
    defaultMessage: "The URL you have entered may be invalid or expired."
  },
  checkEmailForURLMsg: {
    id: "profileSettings.checkEmailForURLMsg",
    defaultMessage: "Please check your email for the right URL or retry verifying your email."
  },
  proceedToColigoLabel: {
    id: "profileSettings.proceedToColigoLabel",
    defaultMessage: "Proceed to Coligo"
  }
});